import type { Clube } from '../core';
import { app } from './app';
import { esc } from './util';

/**
 * Destaque dos clubes dirigidos por técnicos reais (jogadores humanos) quando a sala online tem dois ou mais:
 * etiqueta com o nome do técnico e uma classe para realçar a linha.
 */

/** Nome do técnico humano do clube, só no modo online (no solo o único humano é você). */
export function tecnicoReal(c: Clube): string | null {
  const v = app.online?.visao;
  if (!v || !c.humano) return null;
  return v.sala.jogadores.find((j) => j.clubeId === c.id)?.nome ?? null;
}

/** Etiqueta "👤 Nome" para colocar ao lado do nome do clube ('' se o clube é da CPU). */
export function marcaTecnico(c: Clube): string {
  const nome = tecnicoReal(c);
  return nome ? ` <span class="tec-real" title="Clube de um técnico real: ${esc(nome)}">👤 ${esc(nome)}</span>` : '';
}

/** Classe para realçar a linha quando o clube é de um técnico real. */
export function classeReal(...clubes: Clube[]): string {
  return clubes.some((c) => tecnicoReal(c)) ? ' humano-real' : '';
}
